module.exports = __webpack_public_path__ + "static/media/page-last.2f8e3fe7.svg";